import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_PRFOFILE ({ commit }) {
    const query = `query userProfile {
      userProfile{
        email
        identificationMobileNr
        userProfile{
          anrede,
          firma,
          zusatz,
          vorname,
          name,
          strasse,
          hausNr,
          plz,
          ort,
          land,
          telefon,
          technischerKontakt
        }
      }
    }`

    const { data } = await gql({ query })

    if (!data.errors) {
      commit('SET_PROFILE', data.data.userProfile)
    }

    return data
  },
  async UPDATE_PROFILE ({ commit }, formData) {
    const {
      anrede,
      firma,
      zusatz,
      vorname,
      name,
      strasse,
      hausNr,
      plz,
      ort,
      land,
      telefon,
      technischerKontakt
    } = formData.userProfile

    const {
      identificationMobileNr
    } = formData

    const query = `mutation userProfileUpdate($input: UserProfileUpdateInput!) {
      userProfileUpdate(input: $input) {
        email
        identificationMobileNr
        userProfile{
          anrede,
          firma,
          zusatz,
          vorname,
          name,
          strasse,
          hausNr,
          plz,
          ort,
          land,
          telefon,
          technischerKontakt
        }
      }
    }`

    const variables = {
      input: {
        identificationMobileNr,
        userProfile: {
          anrede,
          firma,
          zusatz,
          vorname,
          name,
          strasse,
          hausNr,
          plz,
          ort,
          land: `${land}`,
          telefon,
          technischerKontakt
        }
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      const { userProfileUpdate } = data.data
      commit('SET_PROFILE', userProfileUpdate)
    }

    return data
  },
  async CHANGE_PASSWORD ({ state }, formData) {
    const {
      oldPassword,
      newPassword
    } = formData

    const query = `mutation userPasswordUpdate($input: UserPasswordChangeInput!) {
      userPasswordUpdate(input: $input) {
        ok
      }
    }`

    const variables = {
      input: {
        oldPassword,
        newPassword
      }
    }

    const { data } = await gql({ query, variables })

    return data
  }
}
